import { createQueryBuilderV4 } from "@odata2ts/odata-query-builder";
import { QResultType } from "../../odata/appu4dm/QAppU4DM";
import { odataFetch } from "../../lib/odata-fetch";
import { ResultType as ResultTypeModel } from "../../odata/appu4dm/AppU4DMModel";
import { useQuery } from "@tanstack/react-query";
import { mtuKeys } from "./mtu-keys";
import { usePersistedState } from "../../lib/usePersistedState";

export function useMTUStatuses() {
  const [selectedStatusResultValue, setSelectedStatusResultValue] =
    usePersistedState<undefined | string>(
      "selectedMTUStatusResultValue",
      undefined
    );

  const { data, ...query } = useQuery({
    queryKey: mtuKeys.getStatuses(),
    queryFn: ({ meta }) => fetchMTUStatuses(meta!.token!),
    enabled: ({ meta }) => !!meta?.token,
  });

  return {
    statuses: data?.value ?? [],
    selectedMTUStatus:
      (selectedStatusResultValue &&
        data?.value.find((x) => x.ResultValue === selectedStatusResultValue)) ||
      data?.value.find((x) => x.IsDefault),
    setSelectedStatus: (val: string) => setSelectedStatusResultValue(val),
    ...query,
  };
}

export type ResultType = Pick<
  ResultTypeModel,
  "Id" | "IsKO" | "IsDefault" | "ResultValue"
>;

async function fetchMTUStatuses(token: string) {
  const builder = createQueryBuilderV4("ResultType", new QResultType()).select(
    "Id",
    "IsKO",
    "IsDefault",
    "ResultValue"
  );

  return odataFetch<ResultType>({ builder, token });
}
